/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { Get } from '../fn/system-settings/get';
import { Get$Params } from '../fn/system-settings/get';
import { GetSystemFeature } from '../fn/system-settings/get-system-feature';
import { GetSystemFeature$Params } from '../fn/system-settings/get-system-feature';
import { GetSystemFeatures } from '../fn/system-settings/get-system-features';
import { GetSystemFeatures$Params } from '../fn/system-settings/get-system-features';
import { GetSystemSettingTypes } from '../fn/system-settings/get-system-setting-types';
import { GetSystemSettingTypes$Params } from '../fn/system-settings/get-system-setting-types';
import { List } from '../fn/system-settings/list';
import { List$Params } from '../fn/system-settings/list';
import { ListSystemFeatures } from '../fn/system-settings/list-system-features';
import { ListSystemFeatures$Params } from '../fn/system-settings/list-system-features';
import { Save } from '../fn/system-settings/save';
import { Save$Params } from '../fn/system-settings/save';
import { SaveSystemFeature } from '../fn/system-settings/save-system-feature';
import { SaveSystemFeature$Params } from '../fn/system-settings/save-system-feature';
import { SaveSystemFeatureOrder } from '../fn/system-settings/save-system-feature-order';
import { SaveSystemFeatureOrder$Params } from '../fn/system-settings/save-system-feature-order';
import { SystemFeatureModel } from '../models/system-feature-model';
import { SystemFeatureViewModelPrimeDatatableResults } from '../models/system-feature-view-model-prime-datatable-results';
import { SystemSettingModel } from '../models/system-setting-model';
import { SystemSettingTypeViewModel } from '../models/system-setting-type-view-model';
import { SystemSettingViewModelPrimeDatatableResults } from '../models/system-setting-view-model-prime-datatable-results';

@Injectable({ providedIn: 'root' })
export class SystemSettingsApiService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiSystemSettingsListPost()` */
  static readonly ApiSystemSettingsListPostPath = '/api/SystemSettings/List';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `List()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  List$Response(params?: List$Params, context?: HttpContext): Observable<StrictHttpResponse<SystemSettingViewModelPrimeDatatableResults>> {
    return List(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `List$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  List(params?: List$Params, context?: HttpContext): Observable<SystemSettingViewModelPrimeDatatableResults> {
    return this.List$Response(params, context).pipe(
      map((r: StrictHttpResponse<SystemSettingViewModelPrimeDatatableResults>): SystemSettingViewModelPrimeDatatableResults => r.body)
    );
  }

  /** Path part for operation `apiSystemSettingsGetPost()` */
  static readonly ApiSystemSettingsGetPostPath = '/api/SystemSettings/Get';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `Get()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  Get$Response(params?: Get$Params, context?: HttpContext): Observable<StrictHttpResponse<SystemSettingModel>> {
    return Get(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `Get$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  Get(params?: Get$Params, context?: HttpContext): Observable<SystemSettingModel> {
    return this.Get$Response(params, context).pipe(
      map((r: StrictHttpResponse<SystemSettingModel>): SystemSettingModel => r.body)
    );
  }

  /** Path part for operation `apiSystemSettingsSavePost()` */
  static readonly ApiSystemSettingsSavePostPath = '/api/SystemSettings/Save';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `Save()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  Save$Response(params?: Save$Params, context?: HttpContext): Observable<StrictHttpResponse<SystemSettingModel>> {
    return Save(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `Save$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  Save(params?: Save$Params, context?: HttpContext): Observable<SystemSettingModel> {
    return this.Save$Response(params, context).pipe(
      map((r: StrictHttpResponse<SystemSettingModel>): SystemSettingModel => r.body)
    );
  }

  /** Path part for operation `apiSystemSettingsListSystemFeaturesPost()` */
  static readonly ApiSystemSettingsListSystemFeaturesPostPath = '/api/SystemSettings/ListSystemFeatures';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ListSystemFeatures()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  ListSystemFeatures$Response(params?: ListSystemFeatures$Params, context?: HttpContext): Observable<StrictHttpResponse<SystemFeatureViewModelPrimeDatatableResults>> {
    return ListSystemFeatures(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `ListSystemFeatures$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  ListSystemFeatures(params?: ListSystemFeatures$Params, context?: HttpContext): Observable<SystemFeatureViewModelPrimeDatatableResults> {
    return this.ListSystemFeatures$Response(params, context).pipe(
      map((r: StrictHttpResponse<SystemFeatureViewModelPrimeDatatableResults>): SystemFeatureViewModelPrimeDatatableResults => r.body)
    );
  }

  /** Path part for operation `apiSystemSettingsGetSystemFeaturesGet()` */
  static readonly ApiSystemSettingsGetSystemFeaturesGetPath = '/api/SystemSettings/GetSystemFeatures';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `GetSystemFeatures()` instead.
   *
   * This method doesn't expect any request body.
   */
  GetSystemFeatures$Response(params?: GetSystemFeatures$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<SystemFeatureModel>>> {
    return GetSystemFeatures(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `GetSystemFeatures$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  GetSystemFeatures(params?: GetSystemFeatures$Params, context?: HttpContext): Observable<Array<SystemFeatureModel>> {
    return this.GetSystemFeatures$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<SystemFeatureModel>>): Array<SystemFeatureModel> => r.body)
    );
  }

  /** Path part for operation `apiSystemSettingsGetSystemFeaturePost()` */
  static readonly ApiSystemSettingsGetSystemFeaturePostPath = '/api/SystemSettings/GetSystemFeature';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `GetSystemFeature()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  GetSystemFeature$Response(params?: GetSystemFeature$Params, context?: HttpContext): Observable<StrictHttpResponse<SystemFeatureModel>> {
    return GetSystemFeature(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `GetSystemFeature$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  GetSystemFeature(params?: GetSystemFeature$Params, context?: HttpContext): Observable<SystemFeatureModel> {
    return this.GetSystemFeature$Response(params, context).pipe(
      map((r: StrictHttpResponse<SystemFeatureModel>): SystemFeatureModel => r.body)
    );
  }

  /** Path part for operation `apiSystemSettingsSaveSystemFeaturePost()` */
  static readonly ApiSystemSettingsSaveSystemFeaturePostPath = '/api/SystemSettings/SaveSystemFeature';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `SaveSystemFeature()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  SaveSystemFeature$Response(params?: SaveSystemFeature$Params, context?: HttpContext): Observable<StrictHttpResponse<SystemFeatureModel>> {
    return SaveSystemFeature(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `SaveSystemFeature$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  SaveSystemFeature(params?: SaveSystemFeature$Params, context?: HttpContext): Observable<SystemFeatureModel> {
    return this.SaveSystemFeature$Response(params, context).pipe(
      map((r: StrictHttpResponse<SystemFeatureModel>): SystemFeatureModel => r.body)
    );
  }

  /** Path part for operation `apiSystemSettingsSaveSystemFeatureOrderPost()` */
  static readonly ApiSystemSettingsSaveSystemFeatureOrderPostPath = '/api/SystemSettings/SaveSystemFeatureOrder';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `SaveSystemFeatureOrder()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  SaveSystemFeatureOrder$Response(params?: SaveSystemFeatureOrder$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return SaveSystemFeatureOrder(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `SaveSystemFeatureOrder$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  SaveSystemFeatureOrder(params?: SaveSystemFeatureOrder$Params, context?: HttpContext): Observable<void> {
    return this.SaveSystemFeatureOrder$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiSystemSettingsGetSystemSettingTypesGet()` */
  static readonly ApiSystemSettingsGetSystemSettingTypesGetPath = '/api/SystemSettings/GetSystemSettingTypes';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `GetSystemSettingTypes()` instead.
   *
   * This method doesn't expect any request body.
   */
  GetSystemSettingTypes$Response(params?: GetSystemSettingTypes$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<SystemSettingTypeViewModel>>> {
    return GetSystemSettingTypes(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `GetSystemSettingTypes$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  GetSystemSettingTypes(params?: GetSystemSettingTypes$Params, context?: HttpContext): Observable<Array<SystemSettingTypeViewModel>> {
    return this.GetSystemSettingTypes$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<SystemSettingTypeViewModel>>): Array<SystemSettingTypeViewModel> => r.body)
    );
  }

}
